import React from 'react';
import './ReadOnlyField.css';

/**
 * Read-only field that looks like an input but renders a div.
 * Value cannot be changed via dev tools (no input to enable).
 * Works with Ant Design Form.Item (receives value from form).
 *
 * @param {*} value - Display value (from Form or explicit)
 * @param {string} placeholder - Shown when value is empty
 * @param {string} size - 'large' | 'middle' | 'small'
 * @param {function} format - Optional: (value) => string (e.g. for dates)
 * @param {Array<{value, label}>} options - Optional: for select-style display; shows label for current value
 */
function ReadOnlyField({
  value,
  placeholder = '',
  size = 'middle',
  className = '',
  style = {},
  format,
  options,
}) {
  let displayValue = value;
  if (format && typeof format === 'function') {
    displayValue = format(value);
  } else if (options && Array.isArray(options) && value != null) {
    const option = options.find((opt) => opt.value === value || String(opt.value) === String(value));
    displayValue = option ? option.label : value;
  }
  const str = displayValue != null && displayValue !== '' ? String(displayValue) : '';
  const showPlaceholder = str === '';

  return (
    <div
      className={`readonly-field readonly-field-${size} ${className}`.trim()}
      style={style}
      role="textbox"
      aria-readonly="true"
    >
      {showPlaceholder ? (
        <span className="readonly-field-placeholder">{placeholder}</span>
      ) : (
        <span className="readonly-field-value" title={str}>{str}</span>
      )}
    </div>
  );
}

export default ReadOnlyField;
